import React, { useEffect } from "react";

import '../components/css/Dashboard-styles.css';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { encryptStorage } from "../constant";
import { getDomainData } from "../service/api";
import AttritionDashboard from "./AttritionDashboard";

function TabComponent({ tab }) {

    useEffect(()=>{
        getDomain()
    },[])
    const navigate = useNavigate()
    const [Tab,setTab]=useState(false)

    const[filterObj,setFilterObj]=useState({
        domain:'',
        from_date:'',
        to_date:''
    })
    let dropDownArraydomain = [];
    const [arrDropDowndomain, setarrDropDowndomain] = useState(dropDownArraydomain);

    async function getDomain() {
        let responsedata = await getDomainData();
        if (responsedata?.data != undefined && responsedata?.data != null && responsedata?.data?.ResponseData[0]?.length != 0) {
            setarrDropDowndomain(responsedata.data.ResponseData);
        }
       // setDomain(response.data.ResponseData)
    }

    function bindDomain() {
        if(arrDropDowndomain){
        return arrDropDowndomain?.map((value,index) => {
           
         return (
                <option value={value}>{value}</option>)
        });
    }
    }


    // const [isActiveOverview, setIsActiveOverview] = useState(false);
    // const [isActiveActivities, setIsActiveActivities] = useState(false);
    // const [isActiveMyteam, setIsActiveMyteam] = useState(false);

    // const handleClick = (activeTab) => {
    //     // 👇️ toggle isActive state on click
    //     if (activeTab == 'Overview') setIsActiveOverview(current => !current);
    //     else if (activeTab == 'Activities') setIsActiveActivities(current => !current);
    //     else if (activeTab == 'MyTeam') setIsActiveMyteam(current => !current);

    // };

    // const inactiveClass = 'nav-link rounded-0 bold-text tab-style';
    // const activeClass = 'nav-link rounded-0 bold-text tab-style active';


    // const handleClick = (MenuName) => {
    //     if (MenuName == 'Overview') {
    //         $("#overview-dashboard-tab").addClass('bold-text tab-style active');
    //         $("#overview-dashboard-tab").addClass('active');

    //         $("#activities-dashboard-tab").removeClass('active');
    //         $("#myteam-dashboard-tab").removeClass('active');

    //     }
    //     else if (MenuName == 'Activities') {
    //         $("#activities-dashboard-tab").addClass('bold-text tab-style active');
    //         $("#overview-dashboard-tab").removeClass('active');
    //         $("#myteam-dashboard-tab").removeClass('active');

    //     }
    //     else if (MenuName == 'MyTeam') {
    //         $("#myteam-dashboard-tab").addClass('bold-text tab-style active');
    //         $("#overview-dashboard-tab").removeClass('active');
    //         $("#activities-dashboard-tab").removeClass('active');

    //     }
    // }

    const toggleClick = (e, route) => {

        // e.preventDefault()

        // if (route == 'overview') navigate('/')
        // else if (route == 'activities') navigate('/')
        // else if (route == 'myteam') navigate('/')

    }


    return (

        <>
            {/* <div class="col-md-12">
                <ul class="nav nav-pills ps-1 dashboard-nav-border" id="pills-tab" role="tablist">
                    <li class="nav-item me-4" onClick={(e) => handleClick('Overview')}>
                        <Link to='/' style={{ "text-decoration": "none" }}>  <button className='nav-link rounded-0 bold-text tab-style active' id="overview-dashboard-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Overview</button></Link>
                    </li>
                    <li class="nav-item me-4" onClick={(e) => handleClick('Activities')} >
                        <Link to='/dashboard/activities' style={{ "text-decoration": "none" }}> <button className='nav-link rounded-0 bold-text tab-style' id="activities-dashboard-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Activities</button></Link>

                    </li>
                    <li class="nav-item" onClick={(e) => handleClick('MyTeam')}>
                        <button className='nav-link rounded-0 bold-text tab-style' id="myteam-dashboard-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true" >My Team</button>
                    </li>
                </ul>
            </div>

            <div class="tab-content" id="pills-tabContent"></div> */}

            < div className="col-md-12" >
               <div className="row dashboard-nav-border justify-content-between">
                <ul className="nav navbar-top nav-pills ps-1 w-auto" id="pills-tab" role="tablist">
                    <li className="nav-item me-4">
                        <button className={`nav-link rounded-0 ${tab == "" ? "active" : null} bold-text tab-style tabattr-style`} id="overview-dashboard-tab"
                            data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab"
                            aria-controls="pills-home" aria-selected="true" onClick={(e) => { toggleClick(e, 'overview'); setTab(false) }}>Overview</button>
                    </li>
                    <li className="nav-item me-4">
                        <button className={`nav-link rounded-0 ${tab == "activities" ? "active" : null} bold-text tab-style tabattr-style`} id="activities-dashboard-tab"
                            data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab"
                            aria-controls="pills-profile" aria-selected="false" onClick={(e) => { toggleClick(e, 'activities'); setTab(false) }}>Activities</button>

                    </li>
                    <li className="nav-item me-4">
                        <button className={`nav-link rounded-0 ${tab == "team" ? "active" : null} bold-text tab-style tabattr-style`} id="myteam-dashboard-tab"
                            data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab"
                            aria-controls="pills-contact" aria-selected="false" onClick={(e) => { toggleClick(e, 'myteam'); setTab(false) }}>My Team</button>
                    </li>
                    
                    {encryptStorage.getItem('groupid')==1 &&
                    <li className="nav-item">
                        <button className={`nav-link rounded-0 ${tab == "attrition" ? "active" : null} bold-text tab-style tabattr-style`} id="Attrition-dashboard-tab"
                            data-bs-toggle="pill" data-bs-target="#pills-Attrition" type="button" role="tab"
                            aria-controls="pills-Attrition" aria-selected="false" onClick={(e) => { toggleClick(e, 'attrition'); setTab(true) }}>Attrition</button>
                    </li>}

                    </ul>
                    

                    {/* {Tab==true?
            
            
                    (<><label  className="input-group flex-nowrap search-group me-2" style={{textAlign:'right'}}>Practice</label>
                    <select>
                        <option value="" >Select</option>
                        {bindDomain()}
                    </select>

                    <label className="bold-text" style={{textAlign:'right'}}>From</label>
                        <input type="date" onChange={(e)=>{setFilterObj({...filterObj,from_date:e.target.value})}}></input>   

                    <label className="bold-text" style={{textAlign:'right'}}>To</label>
                        <input type="date" onChange={(e)=>{setFilterObj({...filterObj,to_date:e.target.value})}}></input>     
                    
                    <AttritionDashboard filterObj={filterObj}/></>):<></>} */}


{Tab==true? (<>
                    <div className="d-flex flex-row gap-4 w-auto navbar-top">
                        <div className="d-flex align-items-center gap-2">
                                <label className="filter-form-label font-14 bold-text"style={{textAlign:'right'}}>Practice</label>
                            <select className="form-select"
                            onChange={(e)=>{setFilterObj({...filterObj,domain:e.target.value})}}> 
                                <option value="" >Select</option>
                                {bindDomain()}
                            </select>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <label className="filter-form-label bold-text font-14" 
                            style={{textAlign:'right'}} >From</label>
                            <input  className="form-control" 
                            type="date" 
                            onChange={(e)=>{setFilterObj({...filterObj,from_date:e.target.value})}} 
                            max={filterObj.to_date}></input>
                        </div>
                        <div className="d-flex align-items-center gap-2"> 
                            <label className=" filter-form-label bold-text font-14" style={{textAlign:'right'}}>To</label>
                            <input  className="form-control" type="date" 
                            onChange={(e)=>{setFilterObj({...filterObj,to_date:e.target.value})}} 
                            min={filterObj.from_date}></input> 
                        </div>
                    </div>
                    <AttritionDashboard filterObj={filterObj}/></>):<></>}
                    </div>
                    
                                
            </div>
        </>
    )
}

export default TabComponent



